import PropTypes from 'prop-types';
import React from 'react';
import { useAsync } from 'react-use';

import { checkRestrictions } from '@mssgme/shared';
import { useWorkspace } from '@mssgme/hooks';

export const IsGranted = ({ renderNoAccess, children, componentNoAccess: Component, ...rest }) => {
    const workspace = useWorkspace();

    const { error } = useAsync(
        () =>
            new Promise((resolve, reject) => {
                checkRestrictions(rest.rule, { ...rest, workspace }, rest.subject, (err, val) =>
                    err ? reject(err) : resolve(val)
                );
            }),
        [workspace, rest.subject, rest.rule]
    );

    if (error) {
        if (Component) return <Component reason={error} {...rest} />;
        if (renderNoAccess) return renderNoAccess(error);

        return null;
    }

    return children || null;
};

IsGranted.propTypes = {
    rule: PropTypes.string.isRequired,
    subject: PropTypes.any,
    renderNoAccess: PropTypes.func,
    componentNoAccess: PropTypes.any,
    children: PropTypes.any,
};
